<template>
  <section class="noData_container">
    <div class="result_content">
      <van-image width="45%" height="auto" fit="contain" :src="result_icon" class="result_icon">
        <template v-slot:loading>
          <van-loading type="spinner" size="100" />
        </template>
      </van-image>
      <div class="result_title">{{ result_title }}</div>
    </div>
    <van-divider>
      <div style="text-align:center;">
        Copyright ©
        {{
          $enumObject.providerConfig[config.projectName].copyrightInfo.subject
        }}
        <br />
      </div>
    </van-divider>
  </section>
</template>

<script>
import noData from '@/assets/payment-related/noData@2x.png'
import { Divider } from 'vant'
import config from '@/config/index'
import { mapGetters } from 'vuex'
export default {
  components: {
    [Divider.name]: Divider
  },
  computed: {
  },
  data () {
    return {
      config,
      result_icon: noData,
      result_title: '您还没有相关订单'
    }
  }
}
</script>

<style lang="scss" scoped>
.noData_container {
  height: calc(100vh - 50px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .result_content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    height: px2rem(325);
    text-align: center;
    .result_icon {
      width: px2rem(120);
      height: auto;
      margin: 0 auto 20px;
    }
    .result_title {
      height: px2rem(40);
      line-height: px2rem(40);
      font-size: px2rem(22);
    }
  }
  .button_box {
    padding: 0 10px 0;
  }
}
</style>
